import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import PAGES from '@/constants/pages';
import getCarsParameters from '@/features/cars/helpers/getCarsParameters';
import { CarsParametersType } from '@/features/cars/types';
import configSelector from '@/features/config/selectors/config';
import { favoritesSelectors } from '@/features/favorites/reducer';
import { RootStateType } from '@/features/store';

import optionsSelector from './options';

const parametersSelector = createSelector(
  [
    configSelector,
    optionsSelector,
    (state: RootStateType) => favoritesSelectors.selectIds(state.favorites),
    (_: RootStateType, offset?: number) => offset ?? 1,
  ],
  (config, options, favoriteCarIds, offset) => {
    const filter: CarsParametersType['filter'] = {
      q: [`id in ['${favoriteCarIds.join(`', '`)}']`],
    };

    const { spaceId, envId } = config;

    const favoriteCarsParameters: CarsParametersType = {
      spaceId,
      envId,
      collectionId: COLLECTION_IDS.vehiclesVehicles,
      filter,
      options: {
        options: {
          ...options,
          offset,
        },
      },
    };

    return getCarsParameters(favoriteCarsParameters, config, PAGES.Favorites);
  },
);

export default parametersSelector;
